import { useFormContext } from "react-hook-form";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

export default function AdviceSection() {
  const { register, formState } = useFormContext();

  return (
    <div className="space-y-2">
      <Textarea
        {...register("advice")}
        placeholder="Add advice for patient (diet, lifestyle, follow-up instructions...)"
        rows={3}
        className={cn(
          "text-xs border border-input rounded-md bg-background transition-all duration-200",
          "focus:border-ring focus:outline-none focus-visible:ring-0",
          "hover:border-ring/60 placeholder:text-muted-foreground placeholder:font-normal",
          "resize-none min-h-[72px]",
          formState.errors?.advice && "border-destructive/30 bg-destructive/5 focus:border-destructive"
        )}
        maxLength={500}
      />
      {formState.errors?.advice && (
        <div className="text-xs text-destructive mt-1">
          {formState.errors.advice.message as string}
        </div>
      )}
    </div>
  );
}